<template>
    <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2" v-if="$can('rp.devices')">
            <devices-settings />
        </div>
        <div class="vx-col w-full lg:w-1/2" v-if="$can('rp.devices')">
            <invoice-devices-settings />
        </div>
    </div>
</template>

<script>
    import devicesSettings from '@/components/calculated-program/settings/DevicesSettings';
    import invoiceDevicesSettings from '@/components/calculated-program/settings/InvoiceDevicesSettings';

    export default {
        name: "Settings",
        components: {
            devicesSettings,
            invoiceDevicesSettings
        }

    }
</script>

